let baseURL: string | undefined = "";

// Production API
if (window.location.href.includes("admin.itexpay.com-staging-env") || window.location.href.includes('localhost')) {
	baseURL = process.env.REACT_APP_ROOT_URL_DEV;
} else {
	baseURL = process.env.REACT_APP_ROOT_URL_PROD;
}

export { baseURL };
